import clsx from 'clsx';
import * as React from 'react';
import { AlertCircle } from '../../icons/alert_circle';
import { Flex } from '../flex';
import { IAlertProps, TypeAlertSize, TypeAlertStatus, TypeAlertType } from './alert.d';

/**
 * Отображает предупреждающее сообщение, требующее внимания.
 *
 * [Ссылка на макет](https://www.figma.com/design/usMdTGGnmZt4s0MRpEhc1o/%D0%A1%D0%BE%D1%81%D1%82%D0%B0%D0%B2%D0%BD%D1%8B%D0%B5-%D0%BA%D0%BE%D0%BC%D0%BF%D0%BE%D0%BD%D0%B5%D0%BD%D1%82%D1%8B?node-id=2354-16&t=g0JnGOuvuZyGzC7U-0)
 */
export const Alert: React.FC<IAlertProps> = ({
  status = 'default' as TypeAlertStatus,
  size = 'middle' as TypeAlertSize,
  type = 'default' as TypeAlertType,
  ...props
}) => {
  return (
    <Flex
      align={'start'}
      gap={'small'}
      className={clsx(`alert alert_status_${status}`, `alert_size_${size}`, `alert_type_${type}`, props.className)}
    >
      {props.icon !== false && (
        <Flex className={'alert__wrap-icon'}>
          {props.icon}
          {props.icon !== false && !props.icon && <AlertCircle />}
        </Flex>
      )}
      <Flex vertical gap={4}>
        <span className={'alert__title'}>{props.title}</span>
        {size == 'large' && props.message && (
          <span className={'alert__text'} dangerouslySetInnerHTML={{ __html: props.message }} />
        )}
      </Flex>
    </Flex>
  );
};
